var _g, _g2, _circle, _circle2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg04(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 86,
    viewBox: "0 0 85 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_312_513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1572 63.0063V57.0274L37.186 48.8441C40.0044 46.2875 42.2289 44.1435 43.8595 42.4122C45.5102 40.6608 46.6778 39.1107 47.3623 37.7619C48.0669 36.4132 48.4192 35.0543 48.4192 33.6854C48.4192 31.6723 47.7448 30.1121 46.396 29.0049C45.0472 27.8977 43.1448 27.3441 40.6888 27.3441C38.8368 27.3441 37.0552 27.6964 35.344 28.401C33.653 29.0854 32.1633 30.1021 30.8749 31.4508L27.7647 24.9888C29.6167 23.3179 31.7405 22.0395 34.1361 21.1538C36.5519 20.268 39.028 19.8251 41.5645 19.8251C44.6245 19.8251 47.2918 20.3586 49.5666 21.4255C51.8415 22.4925 53.5929 23.9923 54.8209 25.9249C56.069 27.8373 56.6931 30.0719 56.6931 32.6285C56.6931 34.3799 56.3508 36.1011 55.6664 37.7921C54.9819 39.463 53.764 41.3453 52.0126 43.4389C50.2813 45.5325 47.8354 48.0691 44.6748 51.0485L39.7527 55.6384H57.8103V63.0063H28.1572Z",
    fill: "black",
    fillOpacity: 0.45
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_312_513)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "url(#paint0_linear_312_513)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 40.5,
    stroke: "white",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_312_513",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 85,
    height: 86
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.8384,
    r: 42.5,
    fill: "#84C5FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_312_513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1756 60.2471V52.7946H27.5856V46.9096L40.3181 21.7471H48.3756L35.9731 46.2221H46.1756V38.3571H52.9681V46.2221H58.4406V52.7946H52.9681V60.2471H46.1756Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_312_513",
    x: 19.8882,
    y: 11.9478,
    width: 45.7997,
    height: 58.9359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.93869,
    result: "effect1_foregroundBlur_312_513"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_312_513",
    x: 0,
    y: 0,
    width: 87,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_312_513"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_312_513",
    x1: 42.5,
    y1: 0,
    x2: 84.663,
    y2: 85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A6DDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7D7F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04);
export default __webpack_public_path__ + "static/media/04.3d7623d706a0b169a8110711b50a516e.svg";
export { ForwardRef as ReactComponent };